module.exports = __webpack_public_path__ + "static/media/noimage.5979bacb.svg";